import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Disposition } from "../../../types/tempTypes";

type InitialState = {
  authFormState: AuthFormState;
  dispositionList: Disposition[];
};


export enum AuthFormState {
  Fresh = "Fresh",
  OtpSent = "OtpSent",
}

const initialState: InitialState = {
  authFormState: AuthFormState.Fresh,
  dispositionList: [],
};

export const tempSlice = createSlice({
  name: "temp",
  initialState,
  reducers: {
    setAuthFormState: (state, action: PayloadAction<AuthFormState>) => {
      state.authFormState = action.payload;
    },
    setDispositionList: (state, action: PayloadAction<any>) => {
      state.dispositionList = action.payload;
    },
  },
});

export const { setAuthFormState, setDispositionList } = tempSlice.actions;
const tempReducer = tempSlice.reducer;
export default tempReducer;
